import { createFileRoute, redirect } from '@tanstack/react-router'

import { isAdminUser, isOrganisationAdminUser } from '@/lib/role-guards'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }
    const canAccessLeaveConfig = isAdminUser(context.auth.user) || isOrganisationAdminUser(context.auth.user)
    // If authenticated, redirect to the default authenticated landing page
    throw redirect({ to: canAccessLeaveConfig ? '/leave/config/leave-types' : '/leave/applications' })
  },
})
